export const SET_CARRITO_ITEMS = "SET_CARRITO_ITEMS";
export const CARRITO_PAGO = "CARRITO_PAGO";
export const GET_ORDENES = "GET_ORDENES";
export const _SUCCESS = "_SUCCESS";
